<div class="role-panel role-panel--manager info-card order-workspace">
  <h2 class="role-panel__title">{{
    'staff.orders.cockpit.managerPanelTitle' | translate
  }}</h2>
      <div class="order-workspace__section order-composition">
      <div class="order-composition__head">
        <h3 class="order-composition__title core-title">
          {{ 'admin.storageRequests.sectionOrderItems' | translate }}
        </h3>
        @if (facade.canManageOrderItems()) {
        <lib-cabinet-button
          class="order-composition__add"
          variant="primary"
          size="md"
          [fullWidth]="true"
          [text]="'admin.storageRequests.orderItemsAddFromCatalog' | translate"
          [action]="{ type: 'action' }"
          [disabled]="facade.saving()"
          (actionEvent)="facade.openCatalogPicker()"
        />
        <lib-cabinet-button
          class="order-composition__add"
          variant="secondary"
          secondaryTone="brand"
          size="md"
          [fullWidth]="true"
          [text]="'admin.storageRequests.orderItemsCreateItem' | translate"
          [action]="{ type: 'action' }"
          [disabled]="facade.saving()"
          (actionEvent)="facade.onCreateClientItem()"
        />
        }
      </div>

      @if (facade.inventoryLoading()) {
      <p class="order-composition__loading">
        {{ 'admin.storageRequests.orderItemsLoading' | translate }}
      </p>
      } @else if (facade.storage(); as inv) {
        @if (facade.orderCompositionHasContent()) {
          @if (inv.lines.length > 0) {
          <div class="order-composition__table-wrap">
            <table class="order-composition__table">
              <thead>
                <tr>
                  <th scope="col">
                    {{ 'admin.storageRequests.orderItemsColName' | translate }}
                  </th>
                  <th scope="col">
                    {{ 'admin.storageRequests.orderItemsColKind' | translate }}
                  </th>
                  <th scope="col">
                    {{ 'admin.storageRequests.orderItemsColStatus' | translate }}
                  </th>
                  @if (facade.canManageOrderItems()) {
                  <th scope="col">
                    <span class="sr-only">{{
                      'admin.storageRequests.orderItemsColActions' | translate
                    }}</span>
                  </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (line of inv.lines; track line.id) {
                <tr
                  class="order-composition__row"
                  [class.order-composition__row--clickable]="!!line.item_id"
                >
                  <td>
                    @if (line.item_id) {
                    <button
                      type="button"
                      class="order-composition__item-link"
                      (click)="facade.openOrderCompositionLine(line)"
                    >
                      {{ facade.orderCompositionLineLabel(line) }}
                    </button>
                    } @else {
                    <span>{{ facade.orderCompositionLineLabel(line) }}</span>
                    }
                  </td>
                  <td>
                    {{
                      (facade.orderCompositionLineKind(line) === 'box'
                        ? 'admin.storageRequests.orderItemsKindBox'
                        : facade.orderCompositionLineKind(line) === 'item'
                          ? 'admin.storageRequests.orderItemsKindItem'
                          : 'admin.storageRequests.orderItemsKindUnknown'
                      ) | translate
                    }}
                  </td>
                  <td>{{ facade.compositionLineStatusLabel(line) }}</td>
                  @if (facade.canManageOrderItems()) {
                  <td class="order-composition__actions-cell">
                    <button
                      type="button"
                      class="order-composition__remove"
                      [disabled]="facade.saving()"
                      (click)="facade.removeOrderCompositionLine(line)"
                    >
                      {{ 'admin.storageRequests.orderItemsRemove' | translate }}
                    </button>
                  </td>
                  }
                </tr>
                }
              </tbody>
            </table>
          </div>
          }

          @if (inv.boxes.length > 0) {
          <div class="order-composition__boxes">
            <h3 class="order-composition__boxes-title">
              {{ 'admin.storageRequests.orderItemsBoxesTitle' | translate }}
            </h3>
            <ul class="order-composition__boxes-list">
              @for (box of inv.boxes; track box.box_id) {
              <li class="order-composition__box">
                <div class="order-composition__box-head">
                  <span class="order-composition__box-label">{{
                    'admin.moverInventory.boxLabel' | translate
                  }}</span>
                  <span class="mono">{{ facade.shortBoxId(box.box_id) }}</span>
                  <span class="order-composition__box-status">{{
                    facade.storageStatusLabel(box.status)
                  }}</span>
                </div>
                @if (box.items.length > 0) {
                <ul class="order-composition__box-items">
                  @for (item of box.items; track item.id) {
                  <li class="order-composition__box-item">
                    <button
                      type="button"
                      class="order-composition__item-link"
                      (click)="facade.openOrderCompositionBoxItem(item)"
                    >
                      {{ facade.orderStorageItemLabel(item) }}
                    </button>
                    <span class="order-composition__box-item-status">{{
                      facade.storageStatusLabel(item.status)
                    }}</span>
                  </li>
                  }
                </ul>
                }
              </li>
              }
            </ul>
          </div>
          }
        } @else {
        <p class="order-composition__empty">
          {{ 'admin.storageRequests.orderItemsEmpty' | translate }}
        </p>
        }
      }
      </div>

      @if (facade.canConfirmClientVisit()) {
      <div class="order-workspace__section confirm-client-visit">
        <h3 class="order-composition__title core-title">{{
          'admin.storageRequests.confirmClientVisitSectionTitle' | translate
        }}</h3>
        <p class="assign-movers__hint">
          {{ 'admin.storageRequests.confirmClientVisitHint' | translate }}
        </p>
        <lib-cabinet-button
          class="processing-action"
          variant="primary"
          size="lg"
          [fullWidth]="true"
          [text]="'staff.orders.cockpit.actions.confirmClientVisit' | translate"
          [action]="{ type: 'action' }"
          [disabled]="facade.saving()"
          [isLoading]="facade.savingMode() === 'confirmVisit'"
          (actionEvent)="facade.confirmClientVisit()"
        />
      </div>
      }

      @if (facade.canAssignMovers()) {
      <div class="order-workspace__section assign-movers">
        <h3 class="order-composition__title core-title">{{
          'admin.storageRequests.assignMoversTitle' | translate
        }}</h3>
        <p class="assign-movers__hint">
          {{ 'admin.storageRequests.assignMoversHint' | translate }}
        </p>
        @if (facade.assignMoversRequiresReason()) {
        <p class="hint">
          {{ 'admin.storageRequests.reassignMoversReasonWarning' | translate }}
        </p>
        <lib-not-input
          type="textarea"
          [label]="'admin.storageRequests.changeReasonLabel' | translate"
          [placeholder]="
            'admin.storageRequests.reassignMoversReasonPlaceholder' | translate
          "
          [ngModel]="facade.assignmentReason()"
          (ngModelChange)="facade.assignmentReason.set($event)"
          [hideErrorBlock]="true"
        />
        }
        <ul class="assign-movers__list">
          @for (m of facade.moverCandidates(); track m.user.id) {
          <li class="assign-movers__row">
            <label class="assign-movers__check">
              <input
                type="checkbox"
                [checked]="facade.isMoverSelected(m.user.id)"
                (change)="facade.toggleMoverSelection(m.user.id)"
              />
              <span>{{ facade.employeeDisplayName(m) }}</span>
            </label>
            @if (facade.isMoverSelected(m.user.id)) {
            <label class="assign-movers__lead">
              <input
                type="radio"
                name="leadMover"
                [checked]="facade.leadMoverId() === m.user.id"
                (change)="facade.setLeadMover(m.user.id)"
              />
              {{ 'admin.storageRequests.assignLeadShort' | translate }}
            </label>
            }
          </li>
          }
        </ul>
        <lib-cabinet-button
          class="processing-action"
          variant="primary"
          size="lg"
          [fullWidth]="true"
          [text]="'admin.storageRequests.assignMoversSubmit' | translate"
          [action]="{ type: 'action' }"
          [disabled]="!facade.canSubmitAssign()"
          [isLoading]="facade.savingMode() === 'assign'"
          (actionEvent)="facade.submitAssignMovers()"
        />
      </div>
      }

      @if (
        facade.row()?.status !== OrderStatuses.New &&
        facade.row()?.status !== OrderStatuses.Completed &&
        facade.row()?.status !== OrderStatuses.Canceled
      ) {
      <div class="order-workspace__section manager-notes">
        <h3 class="order-composition__title core-title">{{
          'admin.storageRequests.addNote' | translate
        }}</h3>
        <lib-not-input
          type="textarea"
          [placeholder]="'admin.storageRequests.addNotePlaceholder' | translate"
          [ngModel]="facade.newNoteText()"
          (ngModelChange)="facade.newNoteText.set($event)"
          [hideErrorBlock]="true"
        />
        <lib-cabinet-button
          class="processing-action processing-action--note"
          variant="secondary"
          secondaryTone="brand"
          size="lg"
          [fullWidth]="true"
          [text]="'admin.storageRequests.submitNote' | translate"
          [action]="{ type: 'action' }"
          [disabled]="!facade.canAddNote() || facade.saving()"
          [isLoading]="facade.savingMode() === 'note'"
          (actionEvent)="facade.addNote()"
        />
      </div>
      }
</div>
